<template>
  <div class="tw-text-sm font-normal" v-if="storeAnswer.data.value">
    {{ date(storeAnswer.data.value) }}
    <span v-if="field.datahash.as_age">
      ( {{ age(storeAnswer.data.value) }} years old )
    </span>
    <span v-if="field.datahash.as_age_in_months">
      ( {{ age_in_months(storeAnswer.data.value) }} months old )
    </span>
</div>
</template>

<script>
// can be the same as address,
// but leaving to make trackable
import mixin from './_mixin_display';
import moment from 'moment';

export default {
  mixins: [mixin],
  skipBasic: true,
  created(){
    this.answer = this.dateAnswerInit(this.field, 0)
  },
  methods: {
    // leaving to make trackable
    dateAnswerInit(field, not_used_option_index) {
      // this one is the same
      return this.basicAnswerInit(field, not_used_option_index)
    },
    age(date){
      return moment().diff(date, 'years');
    },
    age_in_months(date){
      return moment().diff(date, 'months');
    },
    date(date){
      return moment(date).format('ll')
    }
  }
}
</script>